const funcs = [
    "webInit",
    "upload",
    "callAction",
    "login",
    "closePage",
    "hiddenMenu",
    "showMenu",
    "configNavBar",
    "selectAttachment",
    "share",
    "extendParamFun",
    "getAppCode",
    "getAppInfo",
    "openWindow",
    "isShow",
    "fileBrowser",
    "getSystem",
    "previewFile",
    "openRobot",
    "viewImage",
    "previewImImage",
    "viewWatch",
    "backbutton",
    "blockbackbutton",
    "selectContacts",
    "getLocation",
    "faceRecog",
    "openChatWindow",
    "getUserInformation",
    "selectInsideGroup",
    "setYYStorage",
    "getYYStorage",
    "removeYYStorage",
    "getSystemInfo"
]

function handleImgUrl(url) {
    return url;
}

function adaptUrl(url){
    return url;
}

let acts = [
    {
        api: 'handleImgUrl',
        fn: handleImgUrl
    },
    {
        api: 'adaptUrl',
        fn: adaptUrl
    }
];

for (const key of funcs) {
    acts.push({
        api: key,
    })
}

export default acts;